import { useState } from 'react';
import { offersLive } from '../campaign';
import flipkart from '../assets/flipkart.webp';
import amazon from '../assets/amazon.webp';
import swiggy from '../assets/swiggy.webp';
import zomato from '../assets/zomato.webp';

export const BRANDS = [
  ['Flipkart', flipkart],
  ['Amazon', amazon],
  ['Swiggy', swiggy],
  ['Zomato', zomato],
];

export default function VouchersSection({ S, voucher, claimed, onTicket, onCta }) {
  const [paused, setPaused] = useState(false);
  const live = offersLive(S);

  let title = '80 years. ₹80 off.';
  let sub, ctaCls, ctaLabel;
  if (voucher) {
    /* API-driven: copy, eligibility and CTA come from resp.independence.voucher */
    title = voucher.title || title;
    sub = voucher.subTitle || '';
    ctaLabel = (voucher.cta && voucher.cta.text) || 'Buy Vouchers';
    ctaCls = voucher.cta && voucher.cta.enabled === false ? ' gfg-dead' : (!voucher.eligible ? ' gfg-ghost' : '');
  } else if (!live) {
    sub = 'This offer closed on Aug 22nd.<br>Vouchers you already bought still work.';
    ctaCls = ' gfg-dead'; ctaLabel = 'Offer closed';
  } else if (!S.hasCard) {
    sub = '₹80 off needs a GoSats physical card.<br><b>Order by Aug 18th</b> to use it this campaign.';
    ctaCls = ' gfg-ghost'; ctaLabel = 'Get your physical card';
  } else {
    sub = S.phase === 'final48'
      ? '₹80 off every voucher order over ₹800.<br><b>Final 48 hours.</b>'
      : '₹80 off every voucher order over ₹800.<br>Exclusive for physical card holders.';
    ctaCls = ''; ctaLabel = 'Buy Vouchers';
  }

  const off = '₹' + ((voucher && voucher.discount) || 80) + ' off';
  const tickets = BRANDS.map(([name, logo]) => (
    <div
      key={name}
      className={'gfg-ticket' + (claimed.has(name) ? ' gfg-claimed' : '')}
    >
      <span className="gfg-wm" />
      <span className="gfg-logo"><img src={logo} alt={name} /></span>
      <span className="gfg-off">{off}</span>
    </div>
  ));
  /* rail content duplicated for a seamless loop */
  const tickets2 = BRANDS.map(([name, logo]) => (
    <div
      key={name + '-dup'}
      className={'gfg-ticket' + (claimed.has(name) ? ' gfg-claimed' : '')}
      aria-hidden="true"
    >
      <span className="gfg-wm" />
      <span className="gfg-logo"><img src={logo} alt="" /></span>
      <span className="gfg-off">{off}</span>
    </div>
  ));

  return (
    <section className="gfg-vouchers">
      <div className="gfg-band-tri" />
      <h2 className="gfg-sec-title gfg-rv">{title}</h2>
      <p className="gfg-sec-sub gfg-rv" dangerouslySetInnerHTML={{ __html: sub }} />
      <div
        className={'gfg-rail' + (paused ? ' gfg-paused' : '')}
        onPointerDown={() => setPaused(true)}
        onPointerUp={() => setPaused(false)}
        onPointerLeave={() => setPaused(false)}
        onTouchStart={() => setPaused(true)}
        onTouchEnd={() => setPaused(false)}
      >
        <div className="gfg-rail-track">{tickets}{tickets2}</div>
      </div>
      <div className="gfg-cta-wrap gfg-rv" style={{ marginTop: 32 }}>
        <button className={'gfg-cta' + ctaCls} onClick={onCta}>
          <span>{ctaLabel}</span>
          <svg viewBox="0 0 24 24"><path d="M4 12h15M13 6l6 6-6 6" /></svg>
        </button>
      </div>
    </section>
  );
}
